import {connect} from 'react-redux';
import axios from 'axios';
import {Alert, Platform} from "react-native";
import RegisterComplaintsScreen from "../RegisterComplaintsScreen";
import {typeExport} from "../../../../../../redux/store/type";
import i18n from "../../../../../../I18n/i18n";
import {serviceActionListNotSendRegisterComplaints} from "../../../../splash/action/ActionSplashGetAllData";
import {
    callWebservice as callWebserviceListMyRegisterComplaints,
    serviceActionAddSubList
} from "../../action/ActionListMyRegisterComplaintsScreen";
import * as NavigationService from "../../../../../../redux/NavigationService";
import {AsyngStorageClass} from "../../../../../../tools/AsyngStorageClass";
import store from "../../../../../../redux/store";
import HMAlert from "../../../../../../customviews/HMAlert";
import {Tools} from "../../../../../../tools/Tools";


const mapStateToProps = (state) => ({
    results: state.reducerRegisterComplaintsScreen.results,
    isLoading: state.reducerRegisterComplaintsScreen.isLoading,
    NoInternetDialog: state.reducerRegisterComplaintsScreen.NoInternetDialog,

    resultsSet: state.reducerRegisterComplaintsScreen.resultsSet,
    isLoadingSet: state.reducerRegisterComplaintsScreen.isLoadingSet,
    NoInternetDialogSet: state.reducerRegisterComplaintsScreen.NoInternetDialogSet,

    position: state.reducerRegisterComplaintsScreen.position,
    id_category: state.reducerRegisterComplaintsScreen.id_category,


    positionPersonnel: state.reducerRegisterComplaintsScreen.positionPersonnel,
    id_Personnel: state.reducerRegisterComplaintsScreen.id_Personnel,

    CartList: state.reducerSplashGetAllData.CartList,
    PriceAll: state.reducerSplashGetAllData.PriceAll,

    user: state.reducerSplashGetAllData.user,
    wallet: state.reducerSplashGetAllData.wallet,
    DataSplashScreen: state.reducerSplashGetAllData,
    // token: state.reducerSplash.token,

    FoodItem: state.reducerSplashGetAllData.FoodItem,


});

const mapDispatchToProps = (dispatch) => ({
    callService: (url, params, type, typeConnection, token, item, index) => dispatch(callWebservice(url, params, type, typeConnection, token, item, index)),

    callserviceActionRefresh: () => dispatch(serviceActionRefresh()),

});

const getDataDisatch = (dispatch, url, params, type, typeConnection, token, item, index) => {
    let {ListNotSendRegisterComplaints} = store.getState().reducerSplashGetAllData;
    switch (type) {
        case typeExport.TypeGetRegisterComplaintsScreen:
            dispatch(serviceActionPending());

            break;

        case typeExport.TypeSetRegisterComplaintsScreen:
            dispatch(serviceActionPendingSet());

            break;

        default:
    }


    // var date = new Date().getDate(); //Current Date
    // var month = new Date().getMonth() + 1; //Current Month
    // var year = new Date().getFullYear(); //Current Year
    // var hours = new Date().getHours(); //Current Hours
    // var min = new Date().getMinutes(); //Current Minutes
    // var sec = new Date().getSeconds(); //Current Seconds
    // let timeee = date + '_' + month + '_' + year + '_' + hours + '_' + min + '_' + sec;
    // let mobile = store.getState().reducerSplashGetAllData.user.mobile;
    //
    // let DateTime = new Date().getTime()

    // let nameImage = mobile + '_' + DateTime + '.jpg';
    // let nameVideo = mobile + '_' + DateTime + '.mp4';

    //  let nameImage = timeee + params.token + ".jpg";
    // let nameVideo = timeee + params.token + ".mp4";
    /// let nameImage = "0123456789012345678901234567890123456789" + ".jpg";
    // let nameVideo = "0123456789012345678901234567890123456789"  + ".mp4";


    const formData = new FormData();
    formData.append('_operation', typeExport._Contacts);
    // // formData.append('lang', params.lang);
    formData.append('mode', "SaveComplaint");
    formData.append('lang', params.lang);
    formData.append('token', params.token);
    formData.append('type', params.type);


    /*    formData.append('subject', params.subject);
        formData.append('description', params.description);
        formData.append('address', params.address);
        formData.append('longitude', params.longitude);
        formData.append('latitude', params.latitude);  */

    // formData.append('ticket_title', params.ticket_title);
    formData.append('topic', params.topic);
    formData.append('topiccate', params.topiccate);
    formData.append('topicId', params.topicId);
    formData.append('topiccateId', params.topiccateId);
    formData.append('description', params.description);
    formData.append('address', params.address);
    formData.append('place', params.place);
    formData.append('placeName', params.placeName);
    formData.append('person', params.person);
    formData.append('platform', Platform.OS);

    //////////
    // let DateTime = new Date().getTime()
    //
    // let nameImage = DateTime + '.jpg';
    // let nameVideo = DateTime + '.mp4';
    // let nameAudio = DateTime + '.aac';
    // if (params.audio && params.audio !== null) {
    //     formData.append('durationVoice', params.durationVoice);
    //
    //     if (Platform.OS === "web") {
    //         //  formData.append('audio', params.audio, nameAudio + ".aac");
    //         formData.append('audio', params.audioBlob, nameAudio);
    //         //const blobFile = new File([params.audio], nameAudio + ".aac");
    //         //formData.append("audio", params.audioBlob);
    //     }
    //     else
    //         formData.append('audio', {
    //             uri: params.audio,
    //             name: nameAudio,
    //             type: 'audio/aac'
    //         });
    // }
    //
    // // if (params.image && params.image !== null)
    // //     if (Platform.OS === "web") {
    // //         formData.append('image', params.image, nameImage );
    // //
    // //     }
    // //     else
    // //         formData.append('image', {
    // //             uri: params.image,
    // //             name: nameImage,
    // //             type: 'image/jpeg'
    // //         });
    // if (params.video && params.video !== null) {
    //     if (Platform.OS === "web") {
    //         //  formData.append('audio', params.audio, nameAudio + ".aac");
    //         formData.append('video', params.video, nameVideo);
    //         //const blobFile = new File([params.audio], nameAudio + ".aac");
    //         //formData.append("audio", params.audioBlob);
    //     }
    //     else
    //         formData.append('video', {
    //             uri: params.video,
    //             name: nameVideo,
    //             type: 'video/mp4'
    //         });
    // }
    // /*    if (params.video && params.video !== null) formData.append('video', {
    //         uri: params.video,
    //         name: nameVideo,
    //         type: 'video/mp4'
    //     });*/
    // for (let i = 0; i < params.arrImage?.length; i++) {
    //
    //
    //     if (Platform.OS === "web") {
    //         formData.append('image' + "_" + i, params.arrImage[i], `${i}_${nameImage}`);
    //     }
    //     else
    //
    //         formData.append('image' + "_" + i, {
    //             uri: params.arrImage[i],
    //             name: nameImage,
    //             type: 'image/jpeg'
    //         });
    // }
    //////////



    Tools.addAllFormData(formData, true,null,params);
    // formData.append('token_fb', params.token_fb);
    /*    formData.append('_operation',"loginContact");
        formData.append('username', "09186005330");
        formData.append('password', 123456);*/

    const config = {
        headers: {
            "Content-Type": "multipart/form-data; charset=utf-8;",
            // 'Content-Type': 'application/json',
            "Authorization": `Basic ${params.token}`,
            timeout: typeExport._TIMEOUT,
        }
    };
    /*    axios(
            {
                url: baseUrl + url + params,
                method: typeConnection,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                /!*      headers: {'X-Requested-With': 'XMLHttpRequest'},*!/
            }
        )*/
    axios.post(url, formData, config)
        .then(async response => {

            let data = response.data;
            switch (type) {
                case typeExport.TypeGetRegisterComplaintsScreen:

                    break;

                case typeExport.TypeSetRegisterComplaintsScreen:
                    if (response.data.success === true) {
                        // dispatch(serviceActionSuccess(data, token, response.data.user));

                        dispatch(serviceActionSuccessSet(data));

                        let obj = {
                            address: params.address,
                            code: "_",
                            color: "#ff0000",
                            comment: [],
                            createdtime: params.date,
                            // image: params.image,
                            //    video: params.params,
                            /*    files: [
                                    {
                                        file: params.image,
                                        type: "image/jpeg"
                                    },
                                    {
                                        file: params.video,
                                        type: "video/mp4"
                                    },
                                ],*/
                            //   latitude: params.latitude,
                            // longitude: params.longitude,
                            status: i18n.t('constant.registrated'),

                            //  title: params.subject


                            topic: params.topic,
                            topiccate: params.topiccate,
                            description: params.description,
                            place: params.place,
                            placeName: params.placeName,
                            person: params.person,
                        }
                        HMAlert(
                            i18n.t('constant.message'),
                            response.data.message ? response.data.message : ((response.data.result?.message) ? response.data.result.message : i18n.t('constant.RequestSuccessfullyRegistered') + (item ? '\n' + i18n.t('constant.updateTheList') : '')),
                            [
                                {
                                    text: item ? i18n.t('constant.ok') : i18n.t('constant.ok'), onPress: () => {
                                        if (item) {

                                            let paramss = {
                                                "_operation": typeExport._Contacts,

                                                "mode": typeExport.mode,
                                                "lang": i18n.locale,
                                                "token": store.getState().reducerSplashGetAllData.token,
                                                "page": 1,
                                                //"token_fb": this.props.DataSplashScreen.token_fb,
                                            };

                                            store.dispatch(callWebserviceListMyRegisterComplaints(null, typeExport.urlListMyRegisterComplaintsScreen, paramss, typeExport.TypeGetListMyRegisterComplaintsScreen, typeExport._POST, 1, 10, item.type))
                                            // this.props.callService(this.props.route.params.item.link_url, `&lang=${i18n.locale}&after=${after}&page=${page}`, typeExport.TypeGetListMyRegisterComplaintsScreen, _GET, page, typeExport._Count, this.props.route.params.item.id)
                                            //  this.props.callService(typeExport.urlListMyRegisterComplaintsScreen, `&lang=${i18n.locale}&after=${after}&page=${page}`, typeExport.TypeGetListMyRegisterComplaintsScreen, _GET, page, typeExport._Count, null)
                                            //   this.props.callService(typeExport.urlListMyRegisterComplaintsScreen, paramss, typeExport.TypeGetListMyRegisterComplaintsScreen, _POST, 1, 10, null)

                                        } else
                                        //  NavigationService.navigatereset("ApplyScreen", {item: item})
                                            NavigationService.BackTo(1)
                                    }


                                },
                                item ? {
                                    text: i18n.t('constant.NowNot'),
                                    onPress: () => {
                                    },
                                    style: 'cancel'
                                } : {},


                            ],
                            {cancelable: true}
                        )

                        if (item) {
                            ListNotSendRegisterComplaints.splice(index, 1);
                            await AsyngStorageClass.setAsyng(global.IdCity + typeExport.ListMyRegisterComplaintsOffline + item.type, ListNotSendRegisterComplaints);
                            store.dispatch(serviceActionListNotSendRegisterComplaints(ListNotSendRegisterComplaints));


                            let arr = await AsyngStorageClass.getASyng(global.IdCity + typeExport.ListMyRegisterComplaints + item.type)
                            await AsyngStorageClass.setAsyng(global.IdCity + typeExport.ListMyRegisterComplaints + item.type, [obj, ...arr])
                            store.dispatch(serviceActionAddSubList([obj, ...store.getState().reducerListMyRegisterComplaintsScreen.results]))

                        }


                        //   NavigationService.navigatereset('MainStack');
                    } else {
                        dispatch(serviceActionRefresh());
                        //alert(i18n.t('constant.ServerEncounteredProblemTryingAgain'))
                        alert(response.data.error && response.data.error.message ? response.data.error.message : i18n.t('constant.ServerEncounteredProblemTryingAgain'))
                        //   NavigationService.navigatereset('LoginStack');
                    }
                    break;

                default:
            }
        }).catch((e) => {

        switch (type) {
            case typeExport.TypeGetRegisterComplaintsScreen:
                dispatch(serviceActionError(e))

                break;

            case typeExport.TypeSetRegisterComplaintsScreen:
                dispatch(serviceActionErrorSet(e))

                break;

            default:
        }
    })
}


// export const callSetStateCity =  (state_name,state_id,city_name,city_id)  => {

//     return dispatch (serviceActionSuccessSetCityStateData (state_name,state_id,city_name,city_id) )
// }
export const callWebservice = (url, params, type, typeConnection, token, item, index) => {
    return dispatch => {
        //
        // // if (Platform.OS === 'ios') {
        // //     NetInfo.isConnected.addEventListener('connectionChange', (isConnected) => {
        // //             if (isConnected) {
        // //                 getDataDisatch(dispatch, url, params, type, typeConnection, token, item,index);
        // //             }
        // //             else {
        // //                 dispatch(serviceActionError("No Internet Connection"));
        // //             }
        // //         }
        // //     );
        // // }
        // // else {
        //     NetInfo.isConnected.fetch().then(isConnected => {
        //         if (isConnected) {
        //             getDataDisatch(dispatch, url, params, type, typeConnection, token, item,index);
        //         }
        //         else {
        //             switch (type) {
        //
        //                 case TypegetRegisterComplaintsScreen:
        //                     dispatch(serviceActionError("no connect"));
        //                     break;
        //                 default:
        //             }
        //         }
        //     });
        // //}

        // NetInfo.getConnectionInfo().done(
        //     (isConnected) => {
        //         if (isConnected) {
        //             getDataDisatch(dispatch, url, params, type, typeConnection, token, item, index);
        //         } else {
        //             switch (type) {
        //
        //                 case typeExport.TypeGetRegisterComplaintsScreen:
        //                     dispatch(serviceActionError("no connect"));
        //                     break;
        //                 default:
        //             }
        //         }
        //     }
        // )

        if (store.getState().reducerSplashGetAllData.Connection) {
            getDataDisatch(dispatch, url, params, type, typeConnection, token, item, index);
        } else {
            switch (type) {
                case typeExport.TypeGetRegisterComplaintsScreen:
                    dispatch(serviceActionError('error_Connection'))

                    break;

                case typeExport.TypeSetRegisterComplaintsScreen:
                    dispatch(serviceActionErrorSet('error_Connection'))

                    break;

                default:
            }
        }

    }
}


export const serviceActionPending = () => ({
    type: typeExport.RegisterComplaintsScreen_SERVICE_PENDING,
    NoInternetDialog: false,
    isLoading: true,
    showDialohCity: false

})

export const serviceActionError = (error) => ({
    type: typeExport.RegisterComplaintsScreen_SERVICE_ERROR,
    NoInternetDialog: true,
    error: error,
    isLoading: false,
    showDialohCity: false

})

export const serviceActionSuccess = (data) => ({
    type: typeExport.RegisterComplaintsScreen_SERVICE_SUCCESS,
    NoInternetDialog: false,
    results: data,
    isLoading: false,
})

export const serviceActionPendingSet = () => ({
    type: typeExport.RegisterComplaintsScreen_SERVICE_PENDING_Set,
    NoInternetDialogSet: false,
    isLoadingSet: true,

})

export const serviceActionErrorSet = (error) => ({
    type: typeExport.RegisterComplaintsScreen_SERVICE_ERROR_Set,
    NoInternetDialogSet: true,
    error: error,
    isLoadingSet: false,

})

export const serviceActionSuccessSet = (data) => ({
    type: typeExport.RegisterComplaintsScreen_SERVICE_SUCCESS_Set,
    NoInternetDialogSet: false,
    resultsSet: data,
    isLoadingSet: false,
})
export const serviceActionRefresh = () => ({
    type: typeExport.RegisterComplaintsScreen_SERVICE_REFRESH,
    NoInternetDialog: false,
    results: null,
    isLoading: false,
})


export default connect(mapStateToProps, mapDispatchToProps)(RegisterComplaintsScreen);
